export type DeepLayoutModeInput = {
  enableDeep: boolean
  workspaceLayoutEnabled: boolean
  currentSessionId: string | null | undefined
  hasStartedDeepSession: boolean
}

export type DeepLayoutMode = {
  hasNewDeepChrome: boolean
  shouldRenderWorkspace: boolean
  canUseLegacyDeepPanel: boolean
}

type SharedSidebarTargetInput = {
  enableDeep: boolean
  canUseLegacyDeepPanel: boolean
}

export function getDeepLayoutMode({
  enableDeep,
  workspaceLayoutEnabled,
  currentSessionId,
  hasStartedDeepSession,
}: DeepLayoutModeInput): DeepLayoutMode {
  const hasNewDeepChrome = enableDeep && workspaceLayoutEnabled

  return {
    hasNewDeepChrome,
    shouldRenderWorkspace: hasNewDeepChrome && Boolean(currentSessionId) && hasStartedDeepSession,
    canUseLegacyDeepPanel: enableDeep && !workspaceLayoutEnabled,
  }
}

export function getSharedSidebarTarget({
  enableDeep,
  canUseLegacyDeepPanel,
}: SharedSidebarTargetInput): "context" | "legacyDeep" {
  return enableDeep && canUseLegacyDeepPanel ? "legacyDeep" : "context"
}
